import React from "react";
import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";
import { Close } from "@dreamhub/designsystem/icons";
import { Button } from "@/components/ui/button";
import { useLocation, useNavigate } from "react-router-dom";
import ToastBody from "@/components/ui/toast-body";
import { DealColumn, DealStatus } from "@/pages/deals/types";
import { StatusBadge } from "@/components/ui/status-badge";
import { dealStatusColors } from "@/pages/deals/components/DealsTable/DealsTable";
import { getEnumTKey } from "@/utils/strings";
import { IconButton } from "@/components/ui/icon-button";

interface Props {
  dealId: string;
  dealName: string;
  status: DealStatus.CLOSED_LOST | DealStatus.CLOSED_WON;
  handleUndo: () => void;
  hideViewDeal?: boolean;
}

const CloseDealToast: React.FC<Props> = ({
  dealId,
  dealName,
  status,
  handleUndo,
  hideViewDeal = false
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const valueKey = getEnumTKey(
    "stakeholders.dealsModal.table",
    DealColumn.STATUS,
    DealStatus,
    status
  );

  return (
    <ToastBody
      title={
        <span>
          {t("deals.dealView.closeDealToast", { dealName })}
          <span className="inline-block align-text-top px-2 -translate-y-1">
            <StatusBadge
              statusColor={dealStatusColors[status]}
              className="px-1 py-[2px]"
            >
              {t(valueKey)}
            </StatusBadge>
          </span>
        </span>
      }
      actions={
        <>
          <Button
            variant="secondaryNoBg"
            onClick={() => {
              handleUndo();
              toast.dismiss();
            }}
          >
            {t("undo")}
          </Button>
          {!hideViewDeal && (
            <Button
              onClick={() => {
                navigate(`/deals/${dealId}${location.search}`, {
                  replace: true
                });
                toast.dismiss();
              }}
            >
              {t("deals.createModal.view")}
            </Button>
          )}
          <IconButton
            size="md"
            variant="iconNoBg"
            iconColor="secondary"
            onClick={() => toast.dismiss()}
          >
            <Close />
          </IconButton>
        </>
      }
    />
  );
};

export default CloseDealToast;
